import React from 'react';
import PropTypes from 'prop-types';

export default function ListHeaderSortButton(props) {
    const selected = props.module.sortBy.value === props.fieldId;
    return <div className={Classes("sort-icon", {
        'i5-long-arrow-alt-down': !selected || props.module.sortBy.direction === 'asc',
        'i5-long-arrow-alt-up': selected && props.module.sortBy.direction === 'desc',
        'selected':  selected,
    })}/>
}

ListHeaderSortButton.propTypes = {
    module: PropTypes.object,
    fieldId: PropTypes.string,
}